<script setup lang="ts">
const { vacancy } = defineProps<{
  vacancy: Vacancy
}>()

const { t } = useI18n({
  useScope: 'local',
})

type BaseMesssageType =
  | 'primary'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger'
  | 'muted'

const type = computed<BaseMesssageType>(() =>
  vacancyStatusColor(vacancy.status),
)

const { vacancyTypeName } = useVacancyTypeName(vacancy)

// Default icons per style in BaseMessage.
// You can pass an `:icon ` to BaseMessage to customize it further.
// const iconTypeStyle = {
//   info: 'akar-icons:info-fill',
//   warning: 'ci:warning',
//   danger: 'ph:warning-octagon-fill',
//   success: 'carbon:checkmark-filled',
//   primary: '',
//   muted: '',
// }
</script>

<template>
  <BaseMessage
    class="mb-2 max-w-max"
    :type="type"
    icon
  >
    {{
      t(`status.${vacancy.status}`, { vacancyTypeName })
    }}
  </BaseMessage>
</template>

<i18n lang="json">
{
  "en": {
    "status": {
      "draft": "This {vacancyTypeName} has not been published yet.",
      "published": "This {vacancyTypeName} has been published.",
      "filled": "This {vacancyTypeName} has been filled.",
      "expired": "This {vacancyTypeName} has expired.",
      "archived": "This {vacancyTypeName} has been archived."
    }
  },
  "nl": {
    "status": {
      "draft": "Deze {vacancyTypeName} is (nog) niet gepubliceerd. Aanmelden is niet mogelijk.",
      "published": "Deze {vacancyTypeName} is gepubliceerd. Mensen kunnen hier nu op reageren.",
      "filled": "Deze {vacancyTypeName} is vervuld. Aanmelden is niet meer mogelijk.",
      "expired": "Deze {vacancyTypeName} is verlopen. Aanmelden is niet meer mogelijk.",
      "archived": "Deze {vacancyTypeName} is gearchiveerd. Aanmelden is niet meer mogelijk."
    }
  }
}
</i18n>
